import Route from '@ember/routing/route';
import { service } from '@ember/service';

class DevDashboardRoute extends Route {
  @service currentAdmin;
  @service router;

  titleToken = 'Dev Dashboard';

  setupController(controller) {
    super.setupController(...arguments);
    controller.trackLoggedIn();
  }

  beforeModel() {
    this.redirectForNonGlobalAdmins();
  }

  redirectForNonGlobalAdmins() {
    if (!this.currentAdmin.isGlobalAdmin) {
      this.router.transitionTo('apps');
    }
  }
}

export default DevDashboardRoute;
